import { Chip, Tooltip } from '@mui/material';

import { GameElementDto, isOnMain } from '../../hooks/gameElements';

interface BranchBadgeProps {
    element: GameElementDto;
    size?: 'small' | 'medium';
}

// Marker shown next to any element that isn't on Playset's main branch.
// The game will not see the element until the branch is merged.
export const BranchBadge = ({ element, size = 'small' }: BranchBadgeProps) => {
    if (isOnMain(element)) return null;

    return (
        <Tooltip
            title={`This element is only available on the '${element.branch}' Playset branch. The game will not see it until the branch is merged.`}
        >
            <Chip
                size={size}
                color="warning"
                variant="outlined"
                label={`branch: ${element.branch}`}
            />
        </Tooltip>
    );
};
